import { api, ApiRequest } from '../instance';

export const getRaw = api.get;

export async function get<T = any>(url: string, config: ApiRequest = {}): Promise<T> {
  return (await getRaw<T>(url, config)).data;
}

/**
 * @deprecated Use `import { get } from 'services/api';`
 */
export const fetch = get;
